import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRevvlyMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 32,
		height: 32,
		rx: 8,
		fill: "#00d9a6"
	}), /* @__PURE__ */ _jsx("g", {
		transform: "translate(4 6.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1.021 10.5625C4.31511 10.5625 5.13864 2.78709 6.7857 1.15015C8.43276 -0.0775511 8.84453 7.6979 10.0798 13.8364C10.9033 17.5195 12.1386 17.9287 13.3739 15.4733C15.021 12.1995 16.2563 5.24249 17.9033 4.42402C19.1386 4.01479 20.3739 8.51636 22.021 8.51636",
			stroke: "#082535",
			strokeWidth: 2.04195,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
export default SvgRevvlyMark;
